import React from 'react'

const HeroAsset = (props) => {
  return (
    <svg
      width="483"
      height="517"
      viewBox="0 0 483 517"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <path
        d="M284.945 26H390.396L425.546 66.2495V211.148H284.945V26Z"
        fill="#61C9D7"
      />
      <path
        d="M390.744 65.6757V26.6973L425.546 65.6757H390.744Z"
        fill="#05AAC0"
      />
      <line
        x1="311.396"
        y1="78.7261"
        x2="397.705"
        y2="78.7261"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.177"
        y1="60.1499"
        x2="377.805"
        y2="60.1499"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="95.7554"
        x2="397.705"
        y2="95.7554"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="112.789"
        x2="397.705"
        y2="112.789"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="129.818"
        x2="397.705"
        y2="129.818"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="146.849"
        x2="397.705"
        y2="146.849"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="163.882"
        x2="397.705"
        y2="163.882"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <line
        x1="311.396"
        y1="180.912"
        x2="397.705"
        y2="180.912"
        stroke="#05AAC0"
        strokeWidth="2"
      />
      <path
        d="M0 124.872C0 99.5375 20.5375 79 45.8717 79H76V155H0V124.872Z"
        fill="#5CEBA0"
      />
      <g filter="url(#filter0_d_6491_7274)">
        <rect x="39" y="119" width="340" height="374" fill="#F4F5F6" />
      </g>
      <rect
        x="103.5"
        y="146.5"
        width="248"
        height="305"
        fill="white"
        stroke="#D4D7D9"
      />
      <rect
        x="142.871"
        y="348"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="362.951"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="190.233"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="205.809"
        width="80.9901"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="240"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="269.28"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="298.562"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="254.329"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="283.609"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="142.871"
        y="312.891"
        width="46.725"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="240"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="269.28"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="298.562"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="254.329"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="283.609"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <rect
        x="195.826"
        y="312.891"
        width="116.501"
        height="7.47601"
        fill="#D4D7D9"
      />
      <g mixBlendMode="multiply">
        <rect
          x="139.852"
          y="187.588"
          width="52.2982"
          height="13.1404"
          fill="#ABF6CF"
        />
        <rect
          x="139.852"
          y="187.588"
          width="52.2982"
          height="13.1404"
          stroke="#0FAE5C"
        />
      </g>
      <rect
        x="192.648"
        y="201.229"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="192.648"
        y="182.737"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="135"
        y="201.229"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="135"
        y="182.737"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <g mixBlendMode="multiply">
        <rect x="192.501" y="280.5" width="124" height="13" fill="#ABF6CF" />
        <rect x="192.501" y="280.5" width="124" height="13" stroke="#0FAE5C" />
      </g>
      <rect
        x="316.001"
        y="293"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="316.001"
        y="276"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="188.001"
        y="293"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="188.001"
        y="276"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <g mixBlendMode="multiply">
        <rect
          x="139.852"
          y="344.851"
          width="52.2982"
          height="13.1404"
          fill="#ABF6CF"
        />
        <rect
          x="139.852"
          y="344.851"
          width="52.2982"
          height="13.1404"
          stroke="#0FAE5C"
        />
      </g>
      <rect
        x="192.648"
        y="358.492"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="192.648"
        y="340"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect
        x="135"
        y="358.492"
        width="4.35088"
        height="4.35088"
        fill="#0FAE5C"
      />
      <rect x="135" y="340" width="4.35088" height="4.35088" fill="#0FAE5C" />
      <rect
        x="284.917"
        y="184.626"
        width="25.543"
        height="25.543"
        fill="#D4D7D9"
      />
      <rect x="39" y="153" width="37" height="340" fill="#6F787E" />
      <g clipPath="url(#clip0_6491_7274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.501 230.778H64.5003H66.0003H66.001V233.778H66.0003V241.278H66.001V242.778H51.001V242.778V241.278V233.778V230.778H52.501ZM52.501 233.778H64.5003V241.278H52.501V233.778ZM54.0008 235.278H58.5008V236.778H54.0008V235.278ZM63.0008 238.278V239.778H54.0008V238.278H63.0008Z"
          fill="#1D1F21"
        />
      </g>
      <rect
        width="15"
        height="15"
        transform="translate(51.001 171)"
        fill="#6F787E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.501 186V171H58.5009V177H64.5009V186H52.501ZM60.0006 175.5V171L64.5005 175.5H60.0006ZM57.6454 183.629C57.6679 183.611 57.6791 183.582 57.6791 183.541V182.556C57.6791 182.497 57.6521 182.459 57.5981 182.441L56.1266 181.901C56.0996 181.888 56.0996 181.874 56.1266 181.861L57.5981 181.321C57.6521 181.298 57.6791 181.26 57.6791 181.206V180.22C57.6791 180.157 57.6566 180.126 57.6116 180.126C57.6071 180.126 57.5914 180.13 57.5644 180.139L54.8374 181.307C54.7879 181.33 54.7632 181.368 54.7632 181.422V182.34C54.7632 182.389 54.7879 182.428 54.8374 182.455L57.5644 183.622C57.6004 183.64 57.6274 183.643 57.6454 183.629ZM59.3921 183.636C59.3966 183.636 59.4124 183.631 59.4394 183.622L62.1664 182.455C62.2159 182.428 62.2406 182.389 62.2406 182.34V181.422C62.2406 181.368 62.2159 181.33 62.1664 181.307L59.4394 180.139C59.4034 180.121 59.3741 180.121 59.3516 180.139C59.3336 180.153 59.3246 180.18 59.3246 180.22V181.206C59.3246 181.26 59.3516 181.298 59.4056 181.321L60.8771 181.861C60.9041 181.874 60.9041 181.888 60.8771 181.901L59.4056 182.441C59.3516 182.459 59.3246 182.497 59.3246 182.556V183.541C59.3246 183.604 59.3471 183.636 59.3921 183.636Z"
        fill="#1D1F21"
      />
      <g clipPath="url(#clip1_6491_7274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.7561 209.753C59.1378 210.185 59.6419 210.428 60.1388 210.428L60.1532 210.414C60.2181 210.414 60.2829 210.408 60.3477 210.401C61.0424 210.308 61.458 209.809 61.7662 209.439L61.7808 209.422C61.8016 209.397 61.8246 209.368 61.8487 209.339C61.967 209.195 62.1122 209.018 62.1481 208.99C62.1497 208.991 62.1521 208.993 62.1553 208.996C62.1659 209.004 62.1851 209.019 62.2129 209.05C62.2849 209.138 62.3497 209.226 62.4074 209.32C62.4139 209.33 62.4204 209.34 62.427 209.349C62.5374 209.511 62.6628 209.695 62.8395 209.867C63.4516 210.448 64.2726 210.529 64.9855 210.077C65.3528 209.84 65.6769 209.503 66.001 209.003L64.7695 208.301C64.5606 208.625 64.359 208.841 64.1718 208.963C64.0421 209.05 63.9989 209.057 63.8621 208.929C63.8041 208.874 63.75 208.795 63.6913 208.708C63.6697 208.677 63.6476 208.644 63.6244 208.611C63.5308 208.47 63.43 208.335 63.322 208.206C63.0483 207.889 62.7098 207.7 62.3353 207.666C61.4711 207.592 60.967 208.2 60.6357 208.605C60.4845 208.794 60.2685 209.057 60.146 209.071C60.1172 209.071 60.002 209.03 59.8796 208.888C59.5915 208.557 59.3323 208.139 59.0802 207.72C58.965 207.531 58.7705 207.41 58.5401 207.382C58.3096 207.355 58.0864 207.437 57.9279 207.592C57.4382 208.085 56.8549 208.578 56.3148 208.51C56.1275 208.483 55.9259 208.422 55.7242 208.321C55.7422 208.297 55.762 208.274 55.7818 208.25C55.8016 208.227 55.8214 208.203 55.8395 208.179C56.6388 207.16 57.0565 205.931 57.0061 204.722C56.9413 203.108 55.9547 202.028 54.5432 202.028C53.5349 202.028 52.7716 202.467 52.3971 203.27C51.6481 204.85 52.5915 207.382 53.5349 208.375C53.0524 208.672 52.5267 208.909 52.001 209.125L52.5699 210.36C53.2757 210.07 53.9886 209.746 54.6368 209.293C55.1265 209.611 55.6162 209.793 56.1203 209.854C56.9989 209.962 57.7407 209.564 58.2808 209.138C58.4248 209.347 58.5833 209.557 58.7561 209.753ZM53.715 203.817C53.8158 203.601 53.9958 203.378 54.5432 203.378V203.372C55.465 203.372 55.5586 204.533 55.5658 204.769C55.6018 205.674 55.2849 206.599 54.68 207.376L54.6152 207.457C53.9526 206.768 53.2541 204.79 53.715 203.817ZM66.001 211.828H52.001V213.228H66.001V211.828Z"
          fill="#1D1F21"
        />
      </g>
      <rect x="39" y="118.667" width="37" height="36.0989" fill="#1D1F21" />
      <path
        d="M54.6664 134.206C54.6836 134.206 54.7002 134.199 54.7124 134.187C54.7246 134.175 54.7314 134.158 54.7314 134.141V129.563C54.7314 129.546 54.7246 129.529 54.7124 129.517C54.7002 129.505 54.6836 129.498 54.6664 129.498H48.942C48.9248 129.498 48.9082 129.505 48.896 129.517C48.8838 129.529 48.877 129.546 48.877 129.563V130.806C48.877 131.708 49.2333 132.572 49.8677 133.21C50.502 133.848 51.3624 134.206 52.2595 134.206H54.6664Z"
        fill="white"
      />
      <path
        d="M67.5452 129.498H57.1373C57.12 129.498 57.1035 129.505 57.0913 129.517C57.0791 129.529 57.0722 129.546 57.0722 129.563V136.56C57.0722 137.184 56.8255 137.783 56.3863 138.225C55.9472 138.666 55.3515 138.914 54.7305 138.914H51.2828C51.2656 138.914 51.249 138.921 51.2368 138.933C51.2246 138.945 51.2178 138.962 51.2178 138.979V143.557C51.2178 143.574 51.2246 143.591 51.2368 143.603C51.249 143.615 51.2656 143.622 51.2828 143.622H65.2034C65.2207 143.622 65.2372 143.615 65.2494 143.603C65.2616 143.591 65.2685 143.574 65.2685 143.557V138.979C65.2685 138.962 65.2616 138.945 65.2494 138.933C65.2372 138.921 65.2207 138.914 65.2034 138.914H64.0976C63.4765 138.914 62.8809 138.666 62.4417 138.225C62.0025 137.783 61.7558 137.184 61.7558 136.56C61.7558 135.936 62.0025 135.337 62.4417 134.895C62.8809 134.454 63.4765 134.206 64.0976 134.206H67.5452C67.5625 134.206 67.579 134.199 67.5912 134.187C67.6034 134.175 67.6103 134.158 67.6103 134.141V129.563C67.6103 129.546 67.6034 129.529 67.5912 129.517C67.579 129.505 67.5625 129.498 67.5452 129.498V129.498Z"
        fill="white"
      />
      <g mixBlendMode="multiply">
        <circle cx="143" cy="421" r="16" fill="#FCE969" />
      </g>
      <line
        x1="143"
        y1="426.769"
        x2="236.063"
        y2="426.769"
        stroke="#B3B9BD"
        strokeWidth="0.912383"
      />
      <path
        d="M147.473 411.384C154.125 411.384 162.805 403.393 164.491 401.509C166.177 399.625 171.036 392.783 165.026 395.725C159.016 398.667 146.476 419.797 158.183 419.797C161.223 419.797 163.154 419.438 165.681 417.577C165.996 417.345 169.356 414.226 169.4 414.334C169.444 414.442 170.054 416.961 171.036 418.22C172.615 419.771 174.217 420.323 176.421 420.323C177.581 420.323 178.66 420.199 180.14 418.746C181.324 417.583 181.508 417.936 182.847 418.512C186.369 420.025 193.018 422.761 196.741 420.323"
        stroke="black"
        strokeWidth="1.82477"
        strokeLinecap="square"
      />
      <rect
        x="326.68"
        y="395.303"
        width="27.1919"
        height="17.4629"
        transform="rotate(90 326.68 395.303)"
        fill="#2ED27C"
      />
      <rect
        x="294.662"
        y="395.303"
        width="27.1919"
        height="17.4629"
        transform="rotate(90 294.662 395.303)"
        fill="#2ED27C"
      />
      <rect
        x="358.694"
        y="395.303"
        width="27.1919"
        height="17.4629"
        transform="rotate(90 358.694 395.303)"
        fill="#2ED27C"
      />
      <path
        d="M358.695 381.747C358.695 370.941 354.402 360.576 346.76 352.935C339.119 345.293 328.754 341 317.948 341C307.141 341 296.776 345.293 289.135 352.935C281.493 360.576 277.2 370.941 277.2 381.747L317.948 381.747H358.695Z"
        fill="#2ED27C"
      />
      <rect
        x="267.834"
        y="381.748"
        width="100.519"
        height="13.5555"
        fill="#5CEBA0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M401.106 431.226H235.078V489.709H263.713C263.52 488.971 263.417 488.196 263.417 487.396V461.977C263.417 456.938 267.502 452.854 272.54 452.854C277.579 452.854 281.664 456.938 281.664 461.977V487.396C281.664 488.196 281.561 488.971 281.368 489.709H309.265C309.072 488.971 308.969 488.195 308.969 487.396V461.977C308.969 456.938 313.054 452.853 318.093 452.853C323.132 452.853 327.217 456.938 327.217 461.977V487.396C327.217 488.195 327.114 488.971 326.921 489.709H354.817C354.624 488.971 354.521 488.195 354.521 487.396V461.977C354.521 456.938 358.606 452.853 363.645 452.853C368.684 452.853 372.768 456.938 372.768 461.977V487.396C372.768 488.195 372.666 488.971 372.473 489.709H401.106V431.226Z"
        fill="#2ED27C"
      />
      <path d="M209.999 489.26H425.842V503H209.999V489.26Z" fill="#5CEBA0" />
      <path d="M198.843 503H437V516.74H198.843V503Z" fill="#2ED27C" />
      <rect
        x="227.042"
        y="413.764"
        width="182.102"
        height="17.4629"
        fill="#5CEBA0"
      />
      <ellipse
        cx="285"
        cy="26"
        rx="26"
        ry="26"
        transform="rotate(90 285 26)"
        fill="#2ED27C"
      />
      <path
        d="M285 52C288.414 52 291.795 51.3275 294.95 50.0209C298.104 48.7143 300.97 46.7991 303.385 44.3848C305.799 41.9705 307.714 39.1042 309.021 35.9498C310.327 32.7953 311 29.4144 311 26L285 26L285 52Z"
        fill="#0FAE5C"
      />
      <path
        d="M293.116 31.9457C293.116 33.6735 292.565 35.095 291.462 36.2104C290.359 37.3258 288.828 38.0038 286.87 38.2443C286.757 38.2881 286.701 38.3537 286.701 38.4412L286.735 40.6063C286.735 40.7157 286.69 40.8032 286.6 40.8688C286.532 40.9563 286.442 41 286.33 41H283.696C283.584 41 283.482 40.9563 283.392 40.8688C283.325 40.8032 283.291 40.7157 283.291 40.6063L283.325 38.4084C283.325 38.3209 283.268 38.2553 283.156 38.2115C281.198 37.9054 279.656 37.1946 278.53 36.0792C277.427 34.9419 276.876 33.5094 276.876 31.7817V30.9615C276.876 30.8522 276.91 30.7647 276.977 30.6991C277.067 30.6116 277.169 30.5679 277.281 30.5679H280.117C280.23 30.5679 280.32 30.6116 280.387 30.6991C280.477 30.7647 280.522 30.8522 280.522 30.9615V31.5848C280.522 32.5909 280.961 33.4329 281.839 34.1109C282.717 34.767 283.91 35.095 285.418 35.095C286.746 35.095 287.736 34.8107 288.389 34.2421C289.064 33.6735 289.402 32.9408 289.402 32.0441C289.402 31.4317 289.222 30.9178 288.862 30.5023C288.502 30.0649 287.973 29.6821 287.275 29.3541C286.6 29.0041 285.587 28.5558 284.236 28.009C282.728 27.4404 281.502 26.9046 280.556 26.4016C279.611 25.8986 278.823 25.2206 278.193 24.3676C277.562 23.4928 277.247 22.4103 277.247 21.1199C277.247 19.4578 277.765 18.0909 278.8 17.0192C279.858 15.9476 281.288 15.2805 283.088 15.0181C283.201 14.9744 283.257 14.9087 283.257 14.8213L283.19 12.3937C283.19 12.2843 283.223 12.1968 283.291 12.1312C283.381 12.0437 283.482 12 283.595 12H286.228C286.341 12 286.431 12.0437 286.498 12.1312C286.588 12.1968 286.633 12.2843 286.633 12.3937L286.566 14.8541C286.566 14.9416 286.622 15.0072 286.735 15.0509C288.648 15.3571 290.156 16.1007 291.259 17.2817C292.384 18.4627 292.947 19.917 292.947 21.6448V22.2025C292.947 22.3118 292.902 22.4103 292.812 22.4977C292.745 22.5633 292.655 22.5962 292.542 22.5962H289.672C289.56 22.5962 289.458 22.5633 289.368 22.4977C289.301 22.4103 289.267 22.3118 289.267 22.2025V21.8416C289.267 20.8137 288.851 19.9498 288.018 19.25C287.207 18.5283 286.082 18.1674 284.641 18.1674C283.449 18.1674 282.526 18.4189 281.873 18.9219C281.22 19.425 280.894 20.1357 280.894 21.0543C280.894 21.7104 281.063 22.2462 281.4 22.6618C281.76 23.0773 282.278 23.46 282.953 23.81C283.651 24.138 284.709 24.5645 286.127 25.0894C287.658 25.6799 288.873 26.2157 289.773 26.6968C290.696 27.178 291.484 27.856 292.137 28.7308C292.79 29.5837 293.116 30.6554 293.116 31.9457Z"
        fill="#1D1F21"
      />
      <g clipPath="url(#clip2_6491_7274)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M437.302 211.278H450.787V209.031C450.787 205.307 447.768 202.288 444.044 202.288C440.32 202.288 437.302 205.307 437.302 209.031V211.278ZM432.807 211.278H426.064V242.743H462.024V211.278H455.281V209.031C455.281 202.824 450.25 197.793 444.044 197.793C437.838 197.793 432.807 202.824 432.807 209.031V211.278Z"
          fill="#393E42"
        />
        <ellipse
          cx="444.044"
          cy="223.483"
          rx="3.00845"
          ry="3.00845"
          fill="#ABF6CF"
        />
        <path
          d="M447.052 232.508H441.035L444.244 221.227L447.052 232.508Z"
          fill="#ABF6CF"
        />
        <rect
          x="415"
          y="222.938"
          width="22.8203"
          height="7.261"
          fill="#61C9D7"
        />
        <circle cx="418.631" cy="226.569" r="1.55593" fill="#61C9D7" />
        <circle cx="423.817" cy="226.569" r="1.55593" fill="#61C9D7" />
        <circle cx="429.003" cy="226.569" r="1.55593" fill="#61C9D7" />
        <circle cx="434.19" cy="226.569" r="1.55593" fill="#61C9D7" />
        <circle cx="418.631" cy="226.667" r="1.55593" fill="#393E42" />
        <circle cx="423.817" cy="226.667" r="1.55593" fill="#393E42" />
        <circle cx="429.003" cy="226.667" r="1.55593" fill="#393E42" />
        <circle cx="434.19" cy="226.667" r="1.55593" fill="#393E42" />
        <path
          d="M447.053 188.962C447.174 188.587 447.705 188.587 447.827 188.962L448.344 190.553C448.398 190.721 448.554 190.835 448.731 190.835L450.403 190.835C450.797 190.835 450.961 191.339 450.643 191.571L449.289 192.554C449.147 192.658 449.087 192.842 449.141 193.009L449.658 194.601C449.78 194.976 449.351 195.287 449.032 195.056L447.679 194.072C447.536 193.969 447.343 193.969 447.2 194.072L445.848 195.056C445.529 195.287 445.099 194.976 445.221 194.601L445.738 193.009C445.793 192.842 445.733 192.658 445.59 192.554L444.237 191.571C443.918 191.339 444.082 190.835 444.476 190.835L446.149 190.835C446.325 190.835 446.481 190.721 446.536 190.553L447.053 188.962Z"
          fill="#2ED27C"
        />
        <path
          d="M457.827 186.191C457.949 185.816 458.48 185.816 458.602 186.191L459.119 187.783C459.173 187.95 459.33 188.064 459.506 188.064L461.179 188.064C461.573 188.064 461.737 188.569 461.418 188.8L460.065 189.784C459.922 189.888 459.862 190.071 459.917 190.239L460.434 191.83C460.556 192.205 460.127 192.517 459.807 192.285L458.454 191.302C458.311 191.198 458.118 191.198 457.975 191.302L456.622 192.285C456.303 192.517 455.873 192.205 455.995 191.83L456.512 190.239C456.567 190.071 456.507 189.888 456.364 189.784L455.011 188.8C454.692 188.569 454.856 188.064 455.25 188.064L456.923 188.064C457.1 188.064 457.256 187.95 457.31 187.783L457.827 186.191Z"
          fill="#2ED27C"
        />
        <path
          d="M468.603 188.962C468.725 188.587 469.255 188.587 469.377 188.962L469.894 190.553C469.949 190.721 470.105 190.835 470.281 190.835L471.954 190.835C472.349 190.835 472.513 191.339 472.194 191.571L470.84 192.554C470.697 192.658 470.638 192.842 470.692 193.009L471.209 194.601C471.331 194.976 470.902 195.288 470.583 195.056L469.229 194.072C469.087 193.969 468.893 193.969 468.751 194.072L467.397 195.056C467.078 195.288 466.649 194.976 466.771 194.601L467.288 193.009C467.342 192.842 467.283 192.658 467.14 192.554L465.786 191.571C465.467 191.339 465.631 190.835 466.025 190.835L467.699 190.835C467.875 190.835 468.031 190.721 468.086 190.553L468.603 188.962Z"
          fill="#2ED27C"
        />
        <path
          d="M476.298 196.965C476.42 196.59 476.951 196.59 477.072 196.965L477.589 198.557C477.644 198.724 477.8 198.838 477.977 198.838L479.65 198.838C480.044 198.838 480.208 199.343 479.889 199.574L478.535 200.558C478.393 200.661 478.333 200.845 478.388 201.013L478.905 202.604C479.026 202.979 478.597 203.291 478.278 203.059L476.925 202.076C476.782 201.972 476.589 201.972 476.446 202.076L475.092 203.059C474.773 203.291 474.344 202.979 474.466 202.604L474.983 201.013C475.038 200.845 474.978 200.661 474.835 200.558L473.482 199.574C473.163 199.343 473.326 198.838 473.721 198.838L475.394 198.838C475.57 198.838 475.727 198.724 475.781 198.557L476.298 196.965Z"
          fill="#2ED27C"
        />
        <path
          d="M479.376 207.74C479.498 207.365 480.029 207.365 480.151 207.74L480.668 209.332C480.722 209.499 480.878 209.613 481.055 209.613L482.728 209.613C483.122 209.613 483.286 210.117 482.967 210.349L481.614 211.333C481.471 211.436 481.411 211.62 481.466 211.788L481.983 213.379C482.105 213.754 481.675 214.066 481.356 213.834L480.003 212.851C479.86 212.747 479.667 212.747 479.524 212.851L478.171 213.834C477.851 214.066 477.422 213.754 477.544 213.379L478.061 211.788C478.116 211.62 478.056 211.436 477.913 211.333L476.56 210.349C476.241 210.117 476.405 209.613 476.799 209.613L478.472 209.613C478.648 209.613 478.805 209.499 478.859 209.332L479.376 207.74Z"
          fill="#2ED27C"
        />
        <path
          d="M476.298 218.514C476.42 218.139 476.951 218.139 477.072 218.514L477.589 220.106C477.644 220.273 477.8 220.387 477.977 220.387L479.65 220.387C480.044 220.387 480.208 220.891 479.889 221.123L478.535 222.107C478.393 222.21 478.333 222.394 478.388 222.562L478.905 224.153C479.026 224.528 478.597 224.84 478.278 224.608L476.925 223.625C476.782 223.521 476.589 223.521 476.446 223.625L475.092 224.608C474.773 224.84 474.344 224.528 474.466 224.153L474.983 222.562C475.038 222.394 474.978 222.21 474.835 222.107L473.482 221.123C473.163 220.891 473.326 220.387 473.721 220.387L475.394 220.387C475.57 220.387 475.727 220.273 475.781 220.106L476.298 218.514Z"
          fill="#2ED27C"
        />
        <path
          d="M468.603 226.518C468.725 226.143 469.255 226.143 469.377 226.518L469.894 228.109C469.949 228.277 470.105 228.391 470.281 228.391L471.954 228.391C472.349 228.391 472.513 228.895 472.194 229.127L470.84 230.111C470.697 230.214 470.638 230.398 470.692 230.566L471.209 232.157C471.331 232.532 470.902 232.844 470.583 232.612L469.229 231.629C469.087 231.525 468.893 231.525 468.751 231.629L467.397 232.612C467.078 232.844 466.649 232.532 466.771 232.157L467.288 230.566C467.342 230.398 467.283 230.214 467.14 230.111L465.786 229.127C465.467 228.895 465.631 228.391 466.025 228.391L467.699 228.391C467.875 228.391 468.031 228.277 468.086 228.109L468.603 226.518Z"
          fill="#2ED27C"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6491_7274"
          x="26.7129"
          y="109.989"
          width="364.574"
          height="398.574"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.27655" />
          <feGaussianBlur stdDeviation="6.14354" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6491_7274"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6491_7274"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6491_7274">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(51.001 229.278)"
          />
        </clipPath>
        <clipPath id="clip1_6491_7274">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(52.001 200.278)"
          />
        </clipPath>
        <clipPath id="clip2_6491_7274">
          <rect
            width="68"
            height="68"
            fill="white"
            transform="translate(415 183)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HeroAsset
